import { createSelector } from 'reselect';
import { every, flatMap, flow, includes, isEmpty, keys, pick } from 'lodash/fp';

import logging from '../../logging';
import selectRawProduct from '../select-raw-product';

const makeSelectHasAllRequiredProductsLoaded = (productList: string[]) => {
  const selector = createSelector([selectRawProduct], (products) => {
    const loadedProductIds = flow(pick(['data']), flatMap(keys))(products);
    const allLoaded = every((productId: string) => includes(productId, loadedProductIds), productList);
    if (!isEmpty(products?.error)) {
      logging.getLogger().error('All required products haven’t loaded', {
        error: products?.error ?? null,
      });
    }

    return (allLoaded && isEmpty(products?.loading ?? false)) || !isEmpty(products?.error ?? null);
  });

  return selector;
};

export default makeSelectHasAllRequiredProductsLoaded;
